import { GET_ALL_VISIBLE_CLIENTS, GET_CLIENTS_FAIL, GET_CO_BROKER_SALES_AGENT, HANDLE_DOC_SUCCESS } from './types';

const initialState = {
	allVisibleClients: [],
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_ALL_VISIBLE_CLIENTS:
			return {
				...state,
				allVisibleClients: payload,
				allSalesAgentsClients: [],
				loading: false,
			};
		case GET_CO_BROKER_SALES_AGENT:
			return {
				...state,
				coBrokersSalesAgent: payload,
				loading: false,
			};
		case HANDLE_DOC_SUCCESS:
			return {
				...state,
				handleDocFromClient: payload,
				loading: false,
			};
		case GET_CLIENTS_FAIL:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
